<mat-selection-list #docList>
  <mat-list-option *ngFor="let doc of documents | async" [value]="doc">
    {{doc.SNR}} {{doc.SNR_DESCR}} {{doc.VERS_AI}} {{doc.REIFE}} {{doc.DOKU_KOM}}
  </mat-list-option>
</mat-selection-list>

<div class="ps-flex-container-col">
  <div style="justify-self: end">
    <button mat-button (click)="save()">{{'change.prismaDocuments.save' | translate}}</button>
    <button mat-button (click)="dismiss()">{{'change.prismaDocuments.discard' | translate}}</button>
  </div>
</div>
